module.exports = __webpack_public_path__ + "static/media/filter.cdf70e90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter.svg
// module id = 854
// module chunks = 0